import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { getVision } from '../../../services/auth';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { convertToDecimal, convertToSeparator, isNullOrEmpty, newObj, showMessageToast, showMessageToastCustom, translate } from '../../../utils/util';
import ModalReceiptQuantity from './MasterCim/ModalReceiptQuantity';

const ReceiptListItem = (props) => {
    const units = [];
    if (getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD) {
        if (!props.filter.truckKanban && !isNullOrEmpty(props.user.shed) && props.sheds) {
            const shed = props.sheds.find((i) => i.id === props.user.shed);
            if (shed && shed.units) {
                shed.units.forEach((i) => {
                    if (i.warehouseType !== null && i.warehouseType === "SMALL_PARTS") {
                        units.push(i.code);
                    }
                });
            }
        }
    }

    const validStatus = (item, message) => {
        if (item.status === ENUMS.eReceiptStatus.Anomaly.value || item.status === ENUMS.eReceiptStatus.Wait.value) {
            if (message) {
                showMessageToast({ html: "Pendencia Contábil, procurar time SHARED SERVICES", classes: 'red' });
            }
            return false;
        }

        return true;
    }

    const validateMassive = (data) => {
        if (data.balance && data.balance > 0) {
            if (!isNullOrEmpty(data.baiCode)) {
                return true;
            }

            if (data.qme > 0) {
                return (data.balance / data.qme) % 1 === 0
            }
        }

        return false;
    }

    const getStatus = (item) => {
        let result = 'history';

        if (!validStatus(item)) {
            return 'info_outline'
        }

        if (item.accoutingQuantity > item.balance && item.balance > 0) {
            result = 'import_export';
        } else if (item.accoutingQuantity > item.balance && item.balance === 0) {
            result = 'check';
        } else if (item.accoutingQuantity > item.balance && item.balance < 0) {
            result = 'info_outline';
        }

        return result;
    };

    const updateMassiveItem = (item) => {
        if (validateMassive(item) && validStatus(item, true)) {
            if (isCimPallet(item)) {
                props.onSetCimPallet(item);
            } else if (item.visualReceiptIndicator) {
                props.updateVisualItem(item.id, !item.visualReceiptIndicator);
            }
            props.updateMassiveItem(item.id, item.massiveReceiptIndicator ? false : true);
        }
    }

    const updateVisual = (item) => {
        if (validStatus(item, true)) {
            if (isCimPallet(item)) {
                props.onSetCimPallet(item);
            } else if (item.massiveReceiptIndicator) {
                props.updateMassiveItem(item.id, item.massiveReceiptIndicator ? false : true);
            }
            props.updateVisualItem(item.id, !item.visualReceiptIndicator);
        }
    }

    const isCimPallet = (item) => {
        if (props.receiptsCimPallet && props.receiptsCimPallet.length > 0) {
            return props.receiptsCimPallet.find((f) => f.id === item.id);
        }
    }

    const getStatusColor = (item) => {
        let result = 'black-text';

        if (!validStatus(item)) {
            return 'red-text';
        }

        if (item.accoutingQuantity === item.balance) {
            result = 'text-grey-darken-1';
        }
        if (item.accoutingQuantity > item.balance && item.balance > 0) {
            result = 'orange-text';
        } else if (item.accoutingQuantity > item.balance && item.balance === 0) {
            result = 'green-text';
        } else if (item.accoutingQuantity > item.balance && item.balance < 0) {
            result = 'red-text';
        }

        return result;
    };

    return props.data && props.data.partNumberCode && (
        <>
            {
                !props.group && props.data.shed !== "0" && (
                    <>
                        {
                            props.data.perishable === "V" &&
                            <b className="title sixth-text-color right"
                                style={{ position: 'absolute', right: '15px', zIndex: '999' }}
                            >
                                FEFO
                            </b>
                        }
                        {
                            props.data.perishable === 'S' &&
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', right: '15px', zIndex: '999', color: 'red' }}
                            >
                                <i className="mdi mdi-bullhorn-outline" />
                            </span>
                        }
                        {
                            validStatus(props.data) && !props.filter.truckKanban && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD && units.includes(props.data.warehouse) && !props.data.checked &&
                            <span
                                className="title sixth-text-color right"
                                style={{ position: 'absolute', marginTop: '55px', right: '15px', zIndex: '999', cursor: 'pointer' }}
                            >
                                < i onClick={() => {
                                    props.sendCheckReceipts([props.data.id])
                                }} className='material-icons'>visibility</i>
                            </span>
                        }
                        {
                            validStatus(props.data) ?
                                <>
                                    <span
                                        className="title sixth-text-color right"
                                        style={{ position: 'absolute', marginTop: '10px', right: '5px', zIndex: '999', cursor: 'pointer' }}
                                    >
                                        < i onClick={() => {
                                            props.onSetCimPallet(props.data)
                                        }}
                                            className={`mdi mdi-36px mdi-layers-outline ${!isCimPallet(props.data) ? 'gray' : 'green'}-text`} />
                                    </span>
                                    <span
                                        className="title sixth-text-color right"
                                        style={{ position: 'absolute', marginTop: '50px', right: '5px', zIndex: '999', cursor: 'pointer' }}
                                    >
                                        < i onClick={() => updateMassiveItem(props.data)}
                                            className={`mdi mdi-36px mdi-alpha-m-circle-outline ${!props.data.massiveReceiptIndicator ? 'gray' : 'green'}-text`} />
                                    </span>
                                    {
                                        !props.filter.truckKanban &&
                                        <span
                                            className="title sixth-text-color right"
                                            style={{ position: 'absolute', marginTop: '92px', right: '5px', zIndex: '999', cursor: 'pointer' }}
                                        >
                                            < i onClick={() => updateVisual(props.data)}
                                                className={`mdi mdi-36px mdi-package-variant-closed ${!props.data.visualReceiptIndicator ? 'gray' : 'green'}-text`} />
                                        </span>
                                    }
                                    {
                                        props.data.balance > 0 && getVision() !== VISIONS.Faasa && getVision() !== VISIONS.FaasaCKD &&
                                        <span
                                            className="title sixth-text-color right"
                                            style={{ position: 'absolute', marginTop: '130px', right: '5px', zIndex: '999', cursor: 'pointer' }}
                                        >
                                            < i onClick={() => {
                                                props.createConfirmation(props.data, '', props.data.mdr);
                                                props.history.push({
                                                    pathname: `./automaticlow`,
                                                    ...props
                                                })
                                            }}
                                                className={`mdi mdi-36px mdi-arrow-down green-text`} />
                                        </span>
                                    }
                                </> :
                                <span
                                    className="title sixth-text-color right"
                                    style={{ position: 'absolute', marginTop: '100px', right: '5px', zIndex: '999', cursor: 'pointer' }}
                                >
                                    < i onClick={() => {
                                        if (navigator.userAgent !== 'logisticspwa' && props.user.printer?.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
                                            showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
                                        } else {
                                            props.printAnomalyLabel({
                                                receiptId: props.data.id,
                                                printer: props.user.printer
                                            })
                                        }
                                    }}
                                        className="mdi mdi-36px mdi mdi-printer" />
                                </span>
                        }
                    </>
                )
            }
            {(getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) &&
                <span
                    className="black-text right"
                    style={{ position: 'absolute', marginTop: '155px', right: '20px', zIndex: '999' }}
                >
                    {props.index + 1}
                </span>
            }
            {
                (props.group || props.packList) && (
                    <>
                        <span
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', marginTop: props.packList ? '85px' : '70px', right: '40px', zIndex: '999' }}
                        >
                            <ModalReceiptQuantity
                                truckKanban={props.filter.truckKanban}
                                id="ConfirmationItemModalPallet"
                                receipt={newObj(props.data)}
                            />
                        </span>
                    </>
                )
            }
            {props.data.shed === "0" &&
                <span
                    className="subtitle fourth-text-color right"
                    style={{ position: 'absolute', marginTop: '100px', right: '10px', zIndex: '999', width: '20%', textAlign: 'right' }}
                >
                    {translate('physical-confirmation:check-registration')}
                </span>
            }
            <li
                id={`${props.data.partNumberCode}-${props.data.balance}`}
                className="collection-item avatar z-depth-1"
                style={{ backgroundColor: 'white', color: 'black', display: 'block' }}
                onClick={() => props.data.shed !== "0" && props.onSelectedItemChange(props.data)}
            >
                <div className="row" style={{ marginBottom: '0px' }}>
                    <span className="circle">
                        <i style={{ fontSize: '40px' }} className={`material-icons ${getStatusColor(props.data)}`} >
                            {getStatus(props.data)}
                        </i>
                    </span>
                    <div className="title black-text col s8" style={{ padding: '0px', paddingLeft: '0px' }}>
                        {props.data.partNumberCode} {(props.data.massiveIndicationCim || isCimPallet(props.data)) && <small style={{ color: 'red' }}> (CIM PALLET)</small>}
                    </div>
                    <div className="title black-text col s12" style={{ padding: '0px', paddingLeft: '0px' }}>
                        {props.data.partNumberDescription}
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:qme')}: ${convertToSeparator(props.data.qme) || ''}`}</small>
                    </div>
                    <div className="col s8" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:qt-records')}: ${convertToDecimal(props.data.partNumberQuantity) || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('accounting', 'general')}: ${convertToSeparator(props.data.accoutingQuantity) || ''}`}</small>
                    </div>
                    <div className="col s8" style={{ padding: '0px' }}>
                        <small>{`${translate('available', 'general')}: ${convertToSeparator(props.data.balance) || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:mdr-origin')}: ${props.data.mdrOrigin || ''}`}</small>
                    </div>
                    <div className="col s8" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:mdr')}: ${props.data.mdr || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:almox')}: ${props.data.almox || ''}`}</small>
                    </div>
                    <div className="col s4" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:shed')}: ${props.data.shed || ''}`}</small>
                    </div>
                    <div className="col s12" style={{ padding: '0px' }}>
                        <small>{`${translate('physical-confirmation:invoice')}: ${props.data.invoice || ''}`}</small>
                    </div>
                    {
                        !isNullOrEmpty(props.data.lot) && (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) &&
                        <div className="col s4" style={{ padding: '0px' }}>
                            <small>{`Lote: ${props.data.lot}`}</small>
                        </div>
                    }
                    {
                        !validStatus(props.data) &&
                        <div className="col s12" style={{ padding: '0px', color: 'red' }}>
                            <small>Pendencia Contábil, procurar time SHARED SERVICES</small>
                        </div>
                    }
                    {
                        props.data.baiCode &&
                        <div className="col s4" style={{ padding: '0px' }}>
                            <small>{`BAI: ${props.data.baiCode || ''}`}</small>
                        </div>
                    }
                    {
                        props.data.containerNumber &&
                        <div className="col s8" style={{ padding: '0px' }}>
                            <small>{`${translate('physical-confirmation:container-number')}: ${props.data.containerNumber || ''}`}</small>
                        </div>
                    }
                    {
                        props.data.warehouse &&
                        <div className="col s4" style={{ padding: '0px', paddingBottom: '10px' }}>
                            <small>{`${translate('physical-confirmation:supplier')}: ${props.data.warehouse || ''}`}</small>
                        </div>
                    }
                    {
                        (props.data.hotRequest || props.data.precious) &&
                        <div className="col s8" style={{ padding: '0px', color: 'red' }}>
                            {props.data.hotRequest && translate('physical-confirmation:hot-request').toUpperCase()}  {props.data.precious && translate('physical-confirmation:precious-material').toUpperCase()}
                        </div>
                    }
                    {
                        props.data.highCostMaterial &&
                        <div className="col s8" style={{ padding: '0px', color: 'red' }}>
                            {translate('truck-kanban:high-cost-material')}
                        </div>
                    }
                    {
                        props.data.perishable === 'P' &&
                        <div className="title col s12" style={{ padding: '0px', color: 'red' }}>
                            <small>MATERIAL PERECÍVEL</small>
                        </div>
                    }
                </div>
            </li>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        filter: state.physicalConfirmationReducer.filter,
        receiptsGroup: state.physicalConfirmationReducer.receiptsGroup,
        receiptsCimPallet: state.physicalConfirmationReducer.receiptsCimPallet,
        user: state.userReducer.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateMassiveItem: (id, value) => {
            dispatch(PhysicalConfirmationService.updateMassiveIndicator(id, value));
        },
        updateVisualItem: (id, value) => {
            dispatch(PhysicalConfirmationService.updateVisualIndicator(id, value));
        },
        sendCheckReceipts: (ids, callback) => {
            dispatch(PhysicalConfirmationService.checkReceiptsSmallParts(ids, callback));
        },
        printAnomalyLabel: (data, callback) => {
            dispatch(PhysicalConfirmationService.printAnomalyLabel(data, callback));
        },
        createConfirmation: (receiptItem, quantity, mdrType) => {
            dispatch(PhysicalConfirmationService.createConfirmation(receiptItem, quantity, mdrType));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReceiptListItem));